import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 5px 0 20px 0;
`;

export const Steps = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Step = styled.div`
  width: 32px;
  height: 3px;
  margin: 0 4px;
  background: ${(props) => props.theme.colors.neutrals.secondary.gray.stroke};
  border-radius: 1px;

  &.active {
    background: #ffffff;
  }
`;

export const SkipButton = styled.button`
  padding: 5px 16px 7px;
  border: 1px solid ${(props) => props.theme.colors.neutrals.primary[600]};
  border-radius: 4px;
  &:hover {
    border: 1px solid;
    color: ${(props) => props.theme.colors.neutrals.primary[900]};
    background: ${(props) => props.theme.colors.green[300].accent};
  }
`;
